// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-arrow-down[data-v-9a451cbe] {\n  font-size: 12px;\n}\n.block[data-v-9a451cbe] {\n  padding-bottom: 20px;\n  padding-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
